import {
  AgeRange,
  EngagementRateBucket,
  FollowersRangeBucket,
  LastPostWindow,
  LocationCode,
  Provider,
  ViewsRangeBucket,
} from '../types'

export interface IFilterOption<TValue extends string> {
  value: TValue
  labelKey: string
}

export const PLATFORM_OPTIONS: IFilterOption<Provider>[] = [
  { value: 'tiktok', labelKey: 'creatorSearch.filter.platform.tiktok' },
  { value: 'instagram', labelKey: 'creatorSearch.filter.platform.instagram' },
  { value: 'youtube', labelKey: 'creatorSearch.filter.platform.youtube' },
]

export const AGE_RANGE_OPTIONS: IFilterOption<AgeRange>[] = [
  { value: '13-17', labelKey: 'creatorSearch.filter.ageRange.13_17' },
  { value: '18-24', labelKey: 'creatorSearch.filter.ageRange.18_24' },
  { value: '25-34', labelKey: 'creatorSearch.filter.ageRange.25_34' },
  { value: '35-44', labelKey: 'creatorSearch.filter.ageRange.35_44' },
  { value: '45-64', labelKey: 'creatorSearch.filter.ageRange.45_64' },
  { value: '65-', labelKey: 'creatorSearch.filter.ageRange.65_minus' },
]

export const ENGAGEMENT_RATE_OPTIONS: IFilterOption<EngagementRateBucket>[] = [
  { value: 'lt_1pct', labelKey: 'creatorSearch.filter.engagementRate.lt_1pct' },
  { value: '1_3pct', labelKey: 'creatorSearch.filter.engagementRate.1_3pct' },
  { value: '3_5pct', labelKey: 'creatorSearch.filter.engagementRate.3_5pct' },
  { value: '5_9pct', labelKey: 'creatorSearch.filter.engagementRate.5_9pct' },
  { value: 'gt_9pct', labelKey: 'creatorSearch.filter.engagementRate.gt_9pct' },
]

export const FOLLOWERS_OPTIONS: IFilterOption<FollowersRangeBucket>[] = [
  { value: 'lt_10k', labelKey: 'creatorSearch.filter.followers.lt_10k' },
  { value: '10k_20k', labelKey: 'creatorSearch.filter.followers.10k_20k' },
  { value: '20k_50k', labelKey: 'creatorSearch.filter.followers.20k_50k' },
  { value: '50k_100k', labelKey: 'creatorSearch.filter.followers.50k_100k' },
  { value: 'gt_100k', labelKey: 'creatorSearch.filter.followers.gt_100k' },
]

export const LOCATION_OPTIONS: IFilterOption<LocationCode>[] = [
  { value: 'AU', labelKey: 'creatorSearch.filter.location.AU' },
  { value: 'NZ', labelKey: 'creatorSearch.filter.location.NZ' },
  { value: 'US', labelKey: 'creatorSearch.filter.location.US' },
  { value: 'GB', labelKey: 'creatorSearch.filter.location.GB' },
  { value: 'CA', labelKey: 'creatorSearch.filter.location.CA' },
  { value: 'APAC', labelKey: 'creatorSearch.filter.location.APAC' },
  { value: 'EMEA', labelKey: 'creatorSearch.filter.location.EMEA' },
  { value: 'AMER', labelKey: 'creatorSearch.filter.location.AMER' },
]

export const VIEWS_OPTIONS: IFilterOption<ViewsRangeBucket>[] = [
  { value: 'lt_10k', labelKey: 'creatorSearch.filter.views.lt_10k' },
  { value: '10k_50k', labelKey: 'creatorSearch.filter.views.10k_50k' },
  { value: '50k_100k', labelKey: 'creatorSearch.filter.views.50k_100k' },
  { value: '100k_500k', labelKey: 'creatorSearch.filter.views.100k_500k' },
  { value: 'gt_500k', labelKey: 'creatorSearch.filter.views.gt_500k' },
]

export const LAST_POST_OPTIONS: IFilterOption<LastPostWindow>[] = [
  { value: 'lt_1month', labelKey: 'creatorSearch.filter.lastPost.lt_1month' },
  { value: 'lt_3months', labelKey: 'creatorSearch.filter.lastPost.lt_3months' },
  { value: 'lt_6months', labelKey: 'creatorSearch.filter.lastPost.lt_6months' },
  { value: 'lt_1year', labelKey: 'creatorSearch.filter.lastPost.lt_1year' },
]
